module.exports = __webpack_public_path__ + "img/way.d3b3e131.svg";